(function () {
  "use strict";
  if (!/[?&]studio_select=1/.test(location.search)) return;

  var APP_ORIGIN = "https://printworks-studio.fly.dev";
  var target = window.opener || window.parent;
  if (!target || target === window) return;

  var armed = false;
  var hover = null;

  var style = document.createElement("style");
  style.textContent =
    ".pwstudio-hi{outline:2px solid #4f6ef7!important;outline-offset:1px!important;cursor:crosshair!important}" +
    ".pwstudio-bar{position:fixed;z-index:2147483647;left:12px;bottom:12px;display:flex;gap:8px;align-items:center;" +
    "font:13px/1.3 -apple-system,system-ui,sans-serif;background:#111;color:#fff;padding:8px 12px;border-radius:10px;" +
    "box-shadow:0 6px 24px rgba(0,0,0,.3)}" +
    ".pwstudio-bar button{font:inherit;border:0;border-radius:6px;padding:5px 10px;cursor:pointer;background:#fff;color:#111}" +
    ".pwstudio-bar span{opacity:.8}";
  document.head.appendChild(style);

  var bar = document.createElement("div");
  bar.className = "pwstudio-bar";
  var label = document.createElement("span");
  label.textContent = "Studio";
  var btn = document.createElement("button");
  btn.textContent = "Välj element";
  bar.appendChild(label);
  bar.appendChild(btn);
  document.body.appendChild(bar);

  function sectionOf(el) {
    var node = el;
    while (node && node !== document.body) {
      if (node.id && node.id.indexOf("shopify-section-") === 0) {
        return node.id.replace("shopify-section-", "");
      }
      node = node.parentElement;
    }
    return null;
  }

  function selectorChain(el) {
    var parts = [];
    var node = el;
    for (var i = 0; node && node !== document.body && i < 6; i++) {
      var part = node.tagName.toLowerCase();
      if (node.classList.length) {
        part += "." + Array.prototype.slice.call(node.classList)
          .filter(function (c) { return c.indexOf("pwstudio-") !== 0; })
          .slice(0, 4).join(".");
      }
      parts.unshift(part);
      node = node.parentElement;
    }
    return parts.join(" > ");
  }

  // Bara de egenskaper som brukar vara det man vill ändra. Hela
  // getComputedStyle är hundratals rader och gör prompten oläslig.
  var WANTED = ["display","color","background-color","border-radius","border","font-family",
                "font-size","font-weight","padding","margin","transform","transition","opacity"];

  function styles(el) {
    var cs = getComputedStyle(el);
    var out = {};
    WANTED.forEach(function (p) {
      var v = cs.getPropertyValue(p);
      if (v && v !== "none" && v !== "normal" && v !== "auto") out[p] = v.trim();
    });
    return out;
  }

  function disarm() {
    armed = false;
    btn.textContent = "Välj element";
    if (hover) { hover.classList.remove("pwstudio-hi"); hover = null; }
  }

  btn.addEventListener("click", function (e) {
    e.stopPropagation();
    armed = !armed;
    btn.textContent = armed ? "Avbryt" : "Välj element";
    if (!armed && hover) { hover.classList.remove("pwstudio-hi"); hover = null; }
  });

  document.addEventListener("mouseover", function (e) {
    if (!armed) return;
    var el = e.target;
    if (!el || bar.contains(el)) return;
    if (hover) hover.classList.remove("pwstudio-hi");
    hover = el;
    hover.classList.add("pwstudio-hi");
  }, true);

  document.addEventListener("click", function (e) {
    if (!armed) return;
    var el = e.target;
    if (!el || bar.contains(el)) return;
    e.preventDefault();
    e.stopPropagation();

    var payload = {
      source: "pwstudio-bridge",
      version: 1,
      url: location.pathname + location.search.replace(/[?&]studio_select=1/, ""),
      sectionId: sectionOf(el),
      tag: el.tagName.toLowerCase(),
      id: el.id || null,
      classes: Array.prototype.slice.call(el.classList)
        .filter(function (c) { return c.indexOf("pwstudio-") !== 0; }),
      text: (el.textContent || "").trim().slice(0, 120),
      selector: selectorChain(el),
      styles: styles(el),
      dataset: Object.keys(el.dataset || {}).reduce(function (a, k) {
        a[k] = el.dataset[k]; return a;
      }, {})
    };

    target.postMessage(payload, APP_ORIGIN);
    label.textContent = "Skickat till Studio";
    setTimeout(function () { label.textContent = "Studio"; }, 1500);
    disarm();
  }, true);
})();
